import { AccountStatusApiService } from './AccountStatus';
import { FundsApiService } from './FundsApi';
import { getFunctions } from 'firebase/functions';
import { UserAccountsApiService } from './UserAccounts';
// In-memory storage for the deprecated Firebase FundsApi
const memoryStorage = {
    getItem: () => null,
    setItem: () => { },
};
class ApiFactory {
    constructor(firebaseApp) {
        this._id = Math.random().toString(36).substring(7);
        console.log('🏭 ApiFactory constructor, instance id:', this._id);
        if (firebaseApp) {
            this.onFirebaseAppChange(firebaseApp);
        }
    }
    async onFirebaseAppChange(firebaseApp) {
        console.log('🏭 ApiFactory.onFirebaseAppChange called, this instance id:', this._id);
        const functions = getFunctions(firebaseApp);
        this.accountStatusApi = new AccountStatusApiService(functions);
        this.fundsApiService = new FundsApiService(functions, memoryStorage);
        this.userAccountsApi = new UserAccountsApiService(functions);
        console.log('🏭 ApiFactory initialized - userAccountsApi:', !!this.userAccountsApi);
    }
    getAccountStatusApi() {
        return this.accountStatusApi;
    }
    getfundsApiService() {
        return this.fundsApiService;
    }
    getUserAccountsApi() {
        console.log('🏭 getUserAccountsApi called, instance id:', this._id, 'api:', !!this.userAccountsApi);
        return this.userAccountsApi;
    }
}
;
export const ApiFactoryInstance = new ApiFactory();
